import { render } from "./AnnouncementNavButton.vue?vue&type=template&id=dbc175f6"
import script from "./AnnouncementNavButton.vue?vue&type=script&lang=js"
export * from "./AnnouncementNavButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__